var afterMultivariantsAddToCart=(d,p)=>{
  let  _ = _SKT,
    lang_alias = (_.is(Shopify) && _.is(Shopify.locale))?Shopify.locale:'en',
    lang_handle = (lang_alias=='en' || lang_alias=='')?'':('/'+lang_alias),
    lc = String(location),lcr = lc.split(location.origin).join('').split('/');
  lang_handle = (_.is(lcr[1]) && (lcr[1]==lang_alias))?lang_handle:'';
  let mvcartUrl = window.location.origin+lang_handle+'/cart';
  
  if(p[3]){
    mvcartUrl = window.location.origin+lang_handle+'/checkout';
    location = mvcartUrl;
  }else{
    switch(MVData.set.settings.after_addtocart_redirect){
      case 'yes': location = mvcartUrl; break;
      case 'refreash':
        let loc = location+'';
        loc = loc.split('/?').join('?');
        loc = (loc.substr(-1,1) == '/')?loc.substr(0,loc.length-1):loc;
        let hloc = loc.split('#');
        loc = hloc[0];
        loc += (loc.indexOf('?') !== -1)?'&':'?';
        loc += 'mvact=addedtocart';
        loc += _.is(hloc[1])?('#'+hloc[1]):'';
        location = loc;				
        break;
      default: 
        mvResetAll(); 
        if (typeof afterMultivariantsAddToCartCallBack === "function") {
          afterMultivariantsAddToCartCallBack();
        }
        break;
    }
  }
};